import client from './client';

export interface Workflow {
  id: string;
  name: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Execution {
  id: string;
  workflowId: string;
  status: string;
  startedAt: string;
  stoppedAt: string | null;
}

export const getWorkflows = async () => {
  const { data } = await client.get<Workflow[]>('/automation/workflows');
  return data;
};

export const getStats = async () => {
  const { data } = await client.get<Execution[]>('/automation/stats');
  return data;
};

export const toggleWorkflow = async (id: string, active: boolean) => {
  const { data } = await client.patch(`/automation/workflows/${id}/toggle`, { active });
  return data;
};

export const runWorkflow = async (id: string) => {
  const { data } = await client.post(`/automation/workflows/${id}/run`);
  return data;
};
